import { controls } from "../../controls";
                           
const rp806 = {
    label: "Dividend Product",
    pageLabel: "Dividend Product",
    starting: true,
    url: "rp806",
 
    pageType: "history",
    filter: [

    
      ...controls.displayText({ tab: "filter", label: "Member Type", star: true, width: "col-sm-2" }),
      ...controls.select({
        tab: "filter", name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
        options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
      }),   

     
            
      ...controls.displayText({tab: "filter",label: "",width:"col-sm-8 "}),    
    
      ...controls.displayText({ tab: "filter", label: "Member Number", width: "col-sm-2" }),
      ...controls.numberOnly({ tab: "filter", name: "member_number", width: "col-sm-2" }),

 ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

      ...controls.displayText({ tab: "create", label: "Opening Date", width: "col-sm-2" }),
      ...controls.showData({ tab: "create", data: "opening_date", name: "opening_date", width: "col-sm-2" }),


     ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

      ...controls.displayText({tab: "filter",label: "As On Date",star: true,width:"col-sm-2 "}),
      ...controls.magicDate({tab: "filter",name:"as_on_date",isRequired: true,width:"col-sm-2"}),    
    
   

    
    ],

    form:[],

    history: {
        perPage: 10,
        reportHeader: "Dividend Product",
        pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
        displayColumns: [
      
          {
              Header: "Date",
              accessor: "date"
       
          },

          {
              Header: "From Date",
              accessor: "from_date",
        
          },

          {
              Header: "To Date",
              accessor: "to_date",

          },

      
          {
              Header: "Month",
              accessor: "month",
        
          },

      

          {
              Header: "Days",
              accessor: "days",
      
          },
      

     
         {
             Header: "Balance",
             accessor: "balance",
             type: "currency" 
         },

      
          {
              Header: "Product",
              accessor: "product",
      
          },
    
    
          {
              Header: "Rate",
              accessor: "rate",
              type: "currency" 
          },
    
      
          {
              Header: "Dividend",
              accessor: "dividend",
              type: "currency" 
          },
      
      
      
        ]
    }
};

export default rp806;